import type { Fabric } from '@susu/custom-made/utils/interfaces';
import { createContext } from 'react';

type FabricContextType = {
  selectedFabric: Fabric | null;
  setSelectedFabric: (fabric: Fabric | null) => void;
};

const defaultFabricContext: FabricContextType = {
  selectedFabric: null,
  setSelectedFabric: () => {},
};

export const FabricContext = createContext<FabricContextType>(defaultFabricContext);
